import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-emerald-200 bg-emerald-50 p-6" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4 space-y-3"
}
const _hoisted_3 = { class: "text-gray-700" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "mt-1 block text-black"
}

import { onMounted, ref } from "vue";
import { getOrderLabels } from "@/api/orders";
import type { LabelPropsBase, OrderLabel } from "@/types";
import { getTrackingUrl } from "@/utils/trackingUrl";
import { FREE_SHIPPING_CARRIERS } from "@/utils/freeShippingTracking";


export default /*@__PURE__*/_defineComponent({
  __name: 'LabelFreeShipping',
  props: {
    orderId: {},
    orderStatus: {},
    generationEntry: {}
  },
  setup(__props: any) {

const props = __props;
const trackingLabels = ref<OrderLabel[]>([]);

const carrierLabel = (carrierId?: number | null) =>
  FREE_SHIPPING_CARRIERS.find((carrier) => carrier.id === Number(carrierId))
    ?.label || "Transporteur renseigné";

const trackingUrl = (label: OrderLabel) =>
  getTrackingUrl(label.tracking_number, label.id_livraison);

onMounted(async () => {
  try {
    const labels = await getOrderLabels(props.orderId);
    trackingLabels.value = labels.filter((label) => label.tracking_number);
  } catch {
    trackingLabels.value = [];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "text-lg font-semibold text-emerald-900 mb-2" }, "Livraison gratuite", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-emerald-800 text-sm" }, " Les frais de livraison sont offerts par votre boutique. Aucune étiquette eFashion n'est nécessaire. ", -1)),
    (trackingLabels.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-sm font-medium text-black" }, "Suivi communiqué au client", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trackingLabels.value, (label) => {
            return (_openBlock(), _createElementBlock("div", {
              key: label.id_commande_etiquette,
              class: "rounded-md border border-emerald-200 bg-white p-3 text-sm"
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(carrierLabel(label.id_livraison)), 1),
              (trackingUrl(label))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: trackingUrl(label)!,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "mt-1 inline-block font-semibold text-blue-600 underline"
                  }, _toDisplayString(label.tracking_number), 9, _hoisted_4))
                : (_openBlock(), _createElementBlock("strong", _hoisted_5, _toDisplayString(label.tracking_number), 1))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})